// extracted by mini-css-extract-plugin
export default {"root":"SingleDaySelector_root__3GszN","month":"SingleDaySelector_month__NTwc2","day":"SingleDaySelector_day__DS1zI","weekday":"SingleDaySelector_weekday__r94vl"};